import React from 'react';
import styled from '@emotion/styled';
import { Container, HeadingContainer, Title } from './styled';

export type ContentSectionProps = {
  className?: string;
  title?: string;
  more?: React.ReactNode;
  children: React.ReactNode;
};

const SectionTitle = styled(Title)`
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.02em;
`.withComponent('h2');

const ContentSection = ({
  className,
  title,
  more,
  children,
}: ContentSectionProps) => (
  <Container className={`ghc-content-section ${className ?? ''}`}>
    {title !== undefined && (
      <HeadingContainer
        className="ghc-content-section__heading-container"
        responsiveDisabled={true}
      >
        <SectionTitle>{title}</SectionTitle>
        {more}
      </HeadingContainer>
    )}
    {children}
  </Container>
);

export default ContentSection;
